import { render, staticRenderFns } from "./SpeakerMenu.vue?vue&type=template&id=1022cf9c&scoped=true&"
import script from "./SpeakerMenu.vue?vue&type=script&lang=js&"
export * from "./SpeakerMenu.vue?vue&type=script&lang=js&"
import style0 from "./SpeakerMenu.vue?vue&type=style&index=0&id=1022cf9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1022cf9c",
  null
  
)

export default component.exports